import * as React from 'react';

interface IBlockHeader {
  title: string;
  pretitle?: string;
  colour: string;
  img?: string;
  imgAlt?: string;
  imgStyling?: string;
  children?: React.ReactNode;
  id?: string;
}

export const BlockHeader = ({
  title,
  pretitle,
  colour,
  img,
  imgAlt,
  imgStyling,
  children,
  id,
}: IBlockHeader) => {
  return (
    <div id={id} className={`pt-12 text-black ${colour}`}>
      <div
        className={`flex flex-col-reverse lg:flex-row justify-between max-w-screen-xl items-center py-8 md:py-16 mx-8 lg:mx-28 xl:mx-40 2xl:mx-auto lg:gap-6 gap-2`}>
        <div className="lg:w-1/2 pt-6">
          {pretitle && (
            <p className="text-body font-semibold text-center lg:text-left">
              {pretitle}
            </p>
          )}
          <h1 className="text-h2mob lg:text-h2 font-title pb-4 lg:pb-6 pt-2 lg:pt-3 text-center lg:text-left">
            {title}
          </h1>
          {children}
        </div>

        <div className="lg:w-1/2">
          {img && (
            <img
              src={img}
              className={`ml-auto sm:max-w-[28rem] xl:max-w-[32rem] rounded-[2rem] object-cover ${imgStyling}`}
              alt={imgAlt ? imgAlt : `an image of ${img}`}
            />
          )}
        </div>
      </div>
    </div>
  );
};
